import moment from 'moment';

// Global Types
import { AppState } from 'services/types';
import { MyTimesheetEntry } from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEntriesByDate } from 'services/myTimesheetEntries/selectors';
// HACK: disobeys folder structure rules
import {
    selectFirstDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import {
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Utils
// @ts-ignore
import orderBy from 'utils/custom-orderBy';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const selectFilteredMyTimesheetEntriesArray = createDeepEqualSelector(
    [
        (state: AppState) => state,
        selectFirstDate,
        makeSelectQueryStringNumberValue('dayOfWeek')
    ],
    (
        state,
        firstDateState: string,
        queryStringDayOfWeekState: number | undefined
    ) => {
        const date = moment(firstDateState, 'YYYY-MM-DD')
            .add(queryStringDayOfWeekState, 'days')
            .format('YYYY-MM-DD');
        return makeSelectMyTimesheetEntriesByDate(date)(state);
    }
);

const selectOrderedMyTimesheetEntriesArray = createDeepEqualSelector(
    selectFilteredMyTimesheetEntriesArray,
    filteredMyTimesheetEntriesArrayState =>
        orderBy(filteredMyTimesheetEntriesArrayState, ['date', 'startTime'])
);

const selectMyTimesheetEntriesArrayUuids = createDeepEqualSelector(
    selectOrderedMyTimesheetEntriesArray,
    orderedMyTimesheetEntriesArrayState =>
        orderedMyTimesheetEntriesArrayState.map(
            (value: MyTimesheetEntry) => value.uuid
        )
);

export {
    selectFilteredMyTimesheetEntriesArray,
    selectOrderedMyTimesheetEntriesArray,
    selectMyTimesheetEntriesArrayUuids
};
